import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useDispatch, useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { noMoney } from "../../imports";
import { noModal } from "../../redux/modal/modalAction";

export default function TestQuestionTextExplanation({ text }) {
  const modal = useSelector((store) => store.modal);
  const dispatch = useDispatch();
  return (
    <MyModal isVisible={modal.testQuestionTextExplanation}>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <View style={{ width: "90%", marginBottom: 10, minHeight: 100 }}>
          <MyText style={{ textAlign: "center" }}>{`${text}`}</MyText>
        </View>
        <View style={{ marginBottom: 10 }}>
          <MyButton
            text={translate("got it")}
            onPress={() => dispatch(noModal())}
          />
        </View>
      </View>
    </MyModal>
  );
}
